import Main from '../../frame/main/Main';
import MaxWidthWrapper from '../../components/max-width-wrapper/MaxWidthWrapper';
import Image from '../../components/image/Image';
import { PageTitle } from '../../components/typography/Heading';
import { ActionButton } from '@sb1/ffe-buttons-react';
import Selection from '../../project/project-selection/selection/Selection';
import { ProjectCardStyles, THEMES } from '../../utils/cms-utils';
import ProjectCardContext from '../../context/project-card-context';
import styles from './school-event-school-page-od.module.less';
import { Link } from 'react-router';
import SchoolEventBannerOD from '../school-event-elements/SchoolEventBannerOD';
import NavigationList from '../../components/navigation/NavigationList';

const SchoolEventSchoolPageOD = ({ schoolEventData }) => {
    const projectCardOptions = {
        owner: true,
        receiver: false,
        supportButton: false,
    };

    return (
        <Main>
            <MaxWidthWrapper>
                <NavigationList containerClassName={styles.navigation}>
                    <li>
                        <Link to={'/od-2022'}>Tilbake til skolesøk</Link>
                    </li>
                </NavigationList>
                <div className={styles.titleSection}>
                    <Image src={'campaign/od/od-logo-black.svg'} className={styles.image} />
                    <PageTitle className={styles.pageHeader}>{schoolEventData.name}</PageTitle>
                    <p className={styles.description}>
                        Er du elev på skolen og skal jobbe? Start en spleis for å få betalt.
                    </p>
                    <ActionButton
                        as={Link}
                        to={`/school-event/${schoolEventData.event_name}/join/${schoolEventData.organization_number}`}
                        className={styles.buttons}
                    >
                        Start en spleis
                    </ActionButton>
                </div>

                <SchoolEventBannerOD
                    eventId={schoolEventData.event_id}
                    schoolOrgNumber={schoolEventData.organization_number}
                />

                <ProjectCardContext.Provider value={projectCardOptions}>
                    <Selection
                        style={ProjectCardStyles.STANDARD_SMALL}
                        theme={THEMES.WHITE}
                        schoolId={schoolEventData.school_id}
                        eventIds={[schoolEventData.event_id]}
                        contentTitle={'Se hva andre på skolen gjør'}
                        hideSearchWhenLessThanNumberOfHits={4}
                        showSearch={true}
                        showLocationSearch={false}
                    />
                </ProjectCardContext.Provider>
            </MaxWidthWrapper>
        </Main>
    );
};

export default SchoolEventSchoolPageOD;
